import { type TableSelectedCell, useTableRows } from '@/components/custom/erp';

export type SelectedTaxCellInfo = TableSelectedCell;

export interface TaxRow {
  uuid: string;
  line?: number;
  [key: string]: any;
}

const createFieldUpdates = (row: TaxRow, field: string, value: any): Partial<TaxRow> => {
  const updatedRow: TaxRow = { ...row, [field]: value };
  const updates: Partial<TaxRow> = { [field]: value };

  if (field === 'gia_nt0') {
    const so_luong = Number(updatedRow.so_luong) || 1;
    const gia_nt0 = Number(value) || 0;
    const tien_nt0 = gia_nt0 * so_luong;
    updates.tien_nt0 = tien_nt0;
  } else if (field === 'so_luong') {
    const gia_nt0 = Number(updatedRow.gia_nt0) || 0;
    const so_luong = Number(value) || 1;
    const tien_nt0 = gia_nt0 * so_luong;
    updates.tien_nt0 = tien_nt0;
  }

  const shouldCalculateTax = ['tien_nt0', 'gia_nt0', 'ma_thue_data'].includes(field);
  if (shouldCalculateTax) {
    const finalRow = { ...updatedRow, ...updates };
    const baseAmount = finalRow.tien_nt0 || (finalRow.gia_nt0 || 0) * (finalRow.so_luong || 0) || 0;
    const taxRate = finalRow.ma_thue_data?.thue_suat || 0;
    const calculatedTax = (baseAmount * taxRate) / 100;
    updates.thue_nt = calculatedTax;
  }

  return updates;
};

export function useTaxRows(initialRows: TaxRow[] = [], onChange?: (rows: TaxRow[]) => void) {
  const {
    rows,
    setRows,
    selectedRowUuid,
    setSelectedRowUuid,
    selectedRow,
    setSelectedRow,
    selectedCell,
    setSelectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange: baseHandleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    setNonWritableFields,
    setPasteConfigs
  } = useTableRows<TaxRow>({
    initialRows,
    defaultRows: 0,
    onChange,
    onFieldValueChange: createFieldUpdates,
    defaultField: 'ma_thue'
  });

  return {
    rows,
    setRows,
    selectedRowUuid,
    selectedRow,
    selectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange: baseHandleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    setSelectedRowUuid,
    setSelectedRow,
    setSelectedCell,
    setNonWritableFields,
    setPasteConfigs
  };
}
